import agentVerificationPage from 'src/helpers/flows/pages/default/agentVerificationPage';
import backyardExperimentPage from 'src/helpers/flows/pages/default/backyardExperimentPage';
import eligibilityCriteriaPage from 'src/helpers/flows/pages/default/eligibilityCriteriaPage';
import entryTypePage from 'src/helpers/flows/pages/default/entryTypePage';
import floorMaterialsExperimentPage from 'src/helpers/flows/pages/default/floorMaterialsExperimentPage';
import hearAboutOpendoorPage from 'src/helpers/flows/pages/default/hearAboutOpendoorPage';
import hoaGuardPage from 'src/helpers/flows/pages/default/hoaGuardPage';
import hoaTypePage from 'src/helpers/flows/pages/default/hoaTypePage';
import homebuilderDetailsPage from 'src/helpers/flows/pages/default/homebuilderDetailsPage';
import homebuilderNamePage from 'src/helpers/flows/pages/default/homebuilderNamePage';
import homebuilderPage from 'src/helpers/flows/pages/default/homebuilderPage';
import interiorFeaturesExperimentPage from 'src/helpers/flows/pages/default/interiorFeaturesExperimentPage';
import kitchenAppliancePage from 'src/helpers/flows/pages/default/kitchenAppliancePage';
import kitchenCounterPage from 'src/helpers/flows/pages/default/kitchenCounterPage';
import listingAgentPage from 'src/helpers/flows/pages/default/listingAgentPage';
import priceEstimatePage from 'src/helpers/flows/pages/default/priceEstimatePage';
import relationshipPage from 'src/helpers/flows/pages/default/relationshipPage';
import reviewHomeDetailsPage from 'src/helpers/flows/pages/default/reviewHomeDetailsPage';
import saleTimelinePage from 'src/helpers/flows/pages/default/saleTimelinePage';
import sellingReasonPage from 'src/helpers/flows/pages/default/sellingReasonPage';
import upgradesExperimentPage from 'src/helpers/flows/pages/default/upgradesExperimentPage';
import roomConditionExperimentPages from 'src/helpers/flows/pages/roomCondition';
import roomConditionAgentsExperimentPages from 'src/helpers/flows/pages/roomConditionAgents';
import { longboardingPageSet } from 'src/helpers/flows/pageSets/longboarding';
import { FlowPageSet } from 'src/lib/flow/FlowPage';

// While shortboarding is running use pages that exclude the user from seeing
// the account pages while they are in the shortboarding experiment
//
// import accountPage from '../pages/default/accountPage';
import agentEducationPage from '../pages/default/agentEducationPage';
import basicDataPage from '../pages/default/basicDataPage';
import dwellingsTypePage from '../pages/default/dwellingTypePage';
import gatedCommunityPage from '../pages/default/gatedCommunityPage';
import lowConfidenceBasicDataExperimentPage from '../pages/default/lowConfidenceBasicDataExperiment';
import partnerListedPage from '../pages/default/partnerListedPage';
import radioReferralSourcePage from '../pages/default/radioReferralSourcePage';
import sellYourWayPage from '../pages/default/sellYourWayPage';
import {
  accountPageExcludeShortboarding,
  pageSet as shortboardingPageSet,
} from '../pages/default/shortboardingExperimentPages';

const valuationsPageSet = [
  kitchenCounterPage,
  kitchenAppliancePage,
  ...roomConditionExperimentPages,
  ...roomConditionAgentsExperimentPages,
  hoaGuardPage,
  hoaTypePage,
  gatedCommunityPage,
  entryTypePage,
  eligibilityCriteriaPage,
];

const hearAboutOpendoorPageSet = [hearAboutOpendoorPage, radioReferralSourcePage];

const homesWithoutPriorListingExperimentPageSet = [
  upgradesExperimentPage,
  interiorFeaturesExperimentPage,
  floorMaterialsExperimentPage,
  backyardExperimentPage,
];

const optionalPageSet = [priceEstimatePage, sellingReasonPage];

export const defaultPageSet: FlowPageSet = [
  dwellingsTypePage,
  lowConfidenceBasicDataExperimentPage,
  reviewHomeDetailsPage,
  basicDataPage,
  relationshipPage,
  listingAgentPage,
  agentEducationPage,
  saleTimelinePage,
  ...shortboardingPageSet,
  ...valuationsPageSet,
  homebuilderPage,
  partnerListedPage,
  homebuilderNamePage,
  homebuilderDetailsPage,
  ...homesWithoutPriorListingExperimentPageSet,
  ...longboardingPageSet,
  ...hearAboutOpendoorPageSet,
  accountPageExcludeShortboarding,
  agentVerificationPage,
  sellYourWayPage,
  ...optionalPageSet,
];
